// src/components/pagination.jsx
import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ currentPage, totalPages, onPageChange }) {
  // Generate page numbers to display
  const getPageNumbers = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage <= 3) {
      return [1, 2, 3, 4, '...', totalPages];
    }

    if (currentPage >= totalPages - 2) {
      return [1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }

    return [
      1,
      '...',
      currentPage - 1,
      currentPage,
      currentPage + 1,
      '...',
      totalPages,
    ];
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="flex items-center justify-center space-x-1">
      <button
        className={`p-2 rounded-md hover:bg-gray-100 transition-colors ${
          currentPage === 1 ? "text-gray-400 cursor-not-allowed" : "text-gray-700"
        }`}
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeft className="h-5 w-5" />
      </button>

      {getPageNumbers().map((page, index) => (
        <button
          key={index}
          className={`px-3 py-1 rounded-md transition-colors ${
            page === currentPage
              ? "bg-blue-500 text-white"
              : page === "..."
              ? "text-gray-500 cursor-default hover:bg-transparent"
              : "text-gray-700 hover:bg-gray-100"
          }`}
          onClick={() => page !== "..." && onPageChange(page)}
          disabled={page === "..."}
        >
          {page}
        </button>
      ))}

      <button
        className={`p-2 rounded-md hover:bg-gray-100 transition-colors ${
          currentPage === totalPages ? "text-gray-400 cursor-not-allowed" : "text-gray-700"
        }`}
        onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronRight className="h-5 w-5" />
      </button>
    </div>
  );
}